export default __webpack_public_path__ + "static/media/Daz App.5bd5a751.svg";